import React, { useState, useEffect } from 'react'
import { AppContent, AppSidebar, AppFooter, AppHeader, TosAgreement } from '../components/index'
import { Login } from '../views/pages'
import { useSelector } from 'react-redux'
import fusionOidc from '../fusionOidc'
import { needsTosAgreement } from '../utils/tosUtils'

const LoggedOut = () => {
  return (
    <div>
      <Login />
    </div>
  )
}

const LoggedIn = () => {
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)
  const user = useSelector((state) => state.user)
  const token = useSelector((state) => state.token)
  const [tosRefreshKey, setTosRefreshKey] = useState(0)
  const [showTosAgreement, setShowTosAgreement] = useState(false)
  const [tosLoading, setTosLoading] = useState(true)

  // console.log('unfoldable', unfoldable)
  // console.log('sidebarShow', sidebarShow)

  // Check if user needs to agree to TOS
  useEffect(() => {
    const checkTosAgreement = async () => {
      if (user && token?.access_token) {
        try {
          setTosLoading(true)
          const needsAgreement = await needsTosAgreement(user, token.access_token)
          // console.log('==== DefaultLayout.js ==== needsAgreement', needsAgreement)
          setShowTosAgreement(needsAgreement)
        } catch (error) {
          console.error('Error checking TOS agreement:', error)
          setShowTosAgreement(true) // Default to showing TOS if there's an error
        } finally {
          setTosLoading(false)
        }
      } else {
        setTosLoading(false)
        setShowTosAgreement(false)
      }
    }

    checkTosAgreement()
  }, [user, token, tosRefreshKey])

  const handleTosAgreement = (agreementData) => {
    // console.log('TOS agreement recorded:', agreementData)
    // Force a re-render to check TOS status again
    setTosRefreshKey(tosRefreshKey + 1)
  }

  // Show loading state while checking TOS
  if (tosLoading) {
    return <div>Loading...</div>
  }

  // Block access until TOS is agreed - show only TOS component
  if (showTosAgreement) {
    return <TosAgreement key={tosRefreshKey} user={user} onAgree={handleTosAgreement} />
  }

  // Only render full app after TOS agreement
  return (
    <div>
      <AppSidebar />
      <div
        className="wrapper d-flex flex-column min-vh-100 bg-light"
        style={{
          marginLeft: unfoldable || sidebarShow ? '256px' : '20px',
          transition: 'margin-left 0.15s ease-in-out',
        }}
      >
        <AppHeader />
        <div className="body flex-grow-1 px-3">
          <AppContent />
        </div>
        <AppFooter />
      </div>
    </div>
  )
}

const DefaultLayout = () => {
  const token = useSelector((state) => state.token?.id_token)

  /*
  console.log('---ENTERING DefaultLayout')
  if (token) {
    console.log('           token:', token)
    const parts = token.split('.')
    for (let i = 0; i < parts.length; i++) {
      try {
        const json = JSON.parse(atob(parts[i]))
        console.log(`           ${i}: ${JSON.stringify(json)}`)
      } catch (e) {
        console.log(`           raw ${i}: ${parts[i]}`)
      }
    }
  }
  */

  /*
  if (
    window.location.hostname === 'localhost' ||
    window.location.hostname === 'hub.local.fusionmga.dev'
  ) {
    console.log('DefaultLayout -- detected development environment')
    return <LoggedIn />
  }
  */

  // console.log(`DefaultLayout -- token:${token}`)
  if (!token) return <LoggedOut />

  const tval = JSON.parse(atob(token.split('.')[1]))
  if ((tval.exp - 300) * 1000 > Date.now()) return <LoggedIn />

  console.warn('*** TOKEN EXPIRED, logging out')
  fusionOidc.logout()
  return <LoggedOut />
}

export default DefaultLayout
